import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

// Roles that manage the global default parameters and therefore should see the
// default-parameters page rendered at /params.
const DEFAULT_PARAMS_ROLES = ["admin-vs", "superadmin"];

// The /params menu entry is shared: admin-vs/superadmin edit the global default
// parameters, while admin-institution edits the parameters of its own
// institution. Since params are per-institution, redirect the institution admin
// to /institutions/:id/params using the institution it belongs to.
const ParamsRedirect = ({ children }) => {
  const { user } = useAuth();
  const roles = (user?.user?.roles ?? []).map((r) => r.name);

  const managesDefaults = roles.some((r) => DEFAULT_PARAMS_ROLES.includes(r));
  const institutionId = user?.user?.institutions?.[0]?.id;

  if (!managesDefaults && roles.includes("admin-institution") && institutionId) {
    return <Navigate to={`/institutions/${institutionId}/params`} replace />;
  }

  return children;
};

export default ParamsRedirect;
